import { SET_STANDARD_JOB_TYPES } from "../actions/types";

const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_STANDARD_JOB_TYPES:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}
